import { doc, writeBatch } from 'firebase/firestore'
import { db } from '@/firebase/init'
import { FIRST_ORDER_NUMBER } from '@team-milva/lab-models/labAccount'

/** `createLabService` in lab-cloud seeds a new lab with this. */
const FIRST_LAB_PREFIX_NUMBER = 1

/**
 * Resets everything a lab's order *numbering* is made of, so a cleared lab starts over
 * where a freshly created one would: the two counters on its `LabAccount` document.
 *
 * Shared deliberately. This lived only in the seed runner's "Ryd alt" until 2026-09-08,
 * while `orderStore.deleteAllOrdersAndSamples` ("Slet ordrer") deleted the four order
 * collections and left the numbering climbing — so the two clear paths disagreed about
 * what clearing orders meant, and a dev lab's order numbers only ever went up. Both call
 * this now; anything added here reaches both.
 *
 * Both callers are developer-only actions (`isDeveloper`-gated in `HeaderUserMenu` and
 * `OrdersView`), but this lives outside `src/dev/` so production code never imports from
 * the dev-seed folder.
 */
export async function resetOrderNumbering(labAccountID: string): Promise<void> {
  if (!labAccountID) return

  const resetBatch = writeBatch(db)
  resetBatch.update(
    doc(db, 'Apps', '-lab-management-', 'LabAccounts', labAccountID),
    {
      nextLabPrefixNumber: FIRST_LAB_PREFIX_NUMBER,
      nextOrderNumber: FIRST_ORDER_NUMBER,
    }
  )
  await resetBatch.commit()
}
